import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DetailsService } from './details.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HomeService } from '../home/home.service';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { UtilService } from 'src/app/shared/util.service';
import { SaveDraftRequest, UserInput } from './draftrequest.model';
import { Filter } from './draftrequest.model';
import { authConfig } from 'src/app/app.module';
import { Location } from '@angular/common';
import { filter, map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged,throttleTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
})
export class DetailsComponent implements OnInit {
  viewsLists: any = [];
  viewId: any;
  selectedFields: number | undefined;
  userId: number = null;
  operators: any = [];
  fields: any = [];
  selectedOperators: number | undefined;
  requestForm!: FormGroup;
  tabOptions: string[] = ['Filters', 'MySQL'];
  isOptionValue: string = 'Filters';
  limit: number = 100;
  page: number = 1;
  viewName: any = '';
  status: boolean = false;
  indexValue: any;
  viewType: string = '';
  previewResults: any = [];
  previewSchemas: any = [];
  result: any = '';
  condition: string = null;

  options: string[] = ['AND', 'OR'];
  selectedOptions: string[] = [];
  isChecked: boolean = true;
  andOrValue: any;
  errorMessage: any = null;
  warningMessage: string = null;
  errorMessageSubmit: string = null;
  successMessage: string = null;
  activeTabIndex = 0;
  submitReqId: number = null;
  scrollTop: boolean = false;
  lastUpdatedDate: string = null;
  rowIndex = 0;
  formlist: any = [];
  setValueOptional: string = 'AND';
  returnValue: string = '';
  isSubmitButtonDisabled: boolean = false;
  submitDisabledFlag: boolean = false;
  data: any
  customLabel:string='';
  keyword = 'name';
  @ViewChild('auto') auto:any;
  allTags:any=[]
  tagsByViewId:any=[]
  addtagFlag=false;
  savedraftrequestId: any;
  authId: any;
  requestId:any= null;
  userInput: UserInput = {
    condition: '',
    customLabel:'',
    filters: []
  };
  savedraftrequest: any = {
    userId: 0,        // Initialize with default or real values
    viewId: 0,        // Initialize with default or real values
    authId: '', // Initialize with default or real values
    userInput: this.userInput,// Initialize userInput
    requestId: null
  };
  requestUpdatedDate: any;
  updatedDate: any;
  timeInterval: string;
  requestDesc: any = null;
  autocompleteText:any=""
  userType: string;
  tagList: any[];

  ///poc approch 1
 
  

  logicalOperators = ['AND', 'OR'];
  currentStage: string = 'column'; // Start with the 'column' stage
   selectedColumn: any; // Track the selected column
   query = new FormControl('');
 
   // Observable for filtered options based on input
  filteredOptions: Observable<string[]>;
  globalParts: string[];
  valuesList: any=[];

  validColumns: string[] = [];  // To store valid columns
  invalidColumns: string[] = [];  // To store invalid columns
  validOperators: string[] = [];  // To store valid operators
  invalidOperators: string[] = [];  // To store invalid operators
  errorsList: any=[];
  filteredCol: any=[];
  operatorsList: any=[];
  isApplied = false;
  totalPreviewCount: any = 0;
  filteredCount: any= 0;
  isPreviewLoading: boolean = true;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private detailsService: DetailsService,
    private spinner: NgxSpinnerService,
    private utilService: UtilService,
    private homeService: HomeService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    public dialog: MatDialog
  ) {
    this.spinner.show();
    this.userId = +sessionStorage.getItem('userId');
    this.authId = sessionStorage.getItem('id');
    this.userType = sessionStorage.getItem('userType');
    this.activatedRoute.queryParams.subscribe((params: any) => {
      const token = params.token;
      if (token != undefined) {
        sessionStorage.setItem('parentToken', token);
        let reqIdStr = router.url?.split("/")[2]
        let reqId = reqIdStr?.split("?")
        this.cleanURL(router.url.split("/")?.[1], reqId[0]);
        window.location.reload();
      }
    });
    if (router.url.split("/")?.[1] === "jobrequest"||router.url.split("/")?.[1] === "copyrequest") {
      this.detailsService.fetchRequestDetails('DataQuest-' + router.url?.split("/")[2].split("?")?.[0]).subscribe({
        next: res => {
          let resp = JSON.parse(res.result.requestDesc)
          this.requestUpdatedDate=res?.result.requestUpdationDate;
          this.customLabel=resp?.userInput.customLabel;
          this.getTimeInterval();
          this.condition=resp?.userInput.condition;
          this.viewId = resp?.viewId;
          this.detailsService.viewId.next(resp)

          this.homeService.getAllViews(this.userId).subscribe((res: any) => {
            for (const element of res.result) {
              if (element.id == this.viewId) {
                const viewResResult = element;
                this.viewsLists = viewResResult;
                this.viewName = this.viewsLists.displayViewHeading;
                this.viewType = this.viewsLists.viewType;
                this.lastUpdatedDate = this.viewsLists.lastUpdateDate;
                this.requestId=`${router.url?.split("/")[2].split("?")?.[0]}`;
                this.loadPreviewResults();
                this.spinner.hide();
              }
            }
          });
        },
        error: err => { },
        complete: () => { }
      })
    } else {
      this.viewId = +this.route.snapshot.params['id'];
      this.homeService.getAllViews(this.userId).subscribe((res: any) => {
        for (const element of res.result) {
          if (element.id == this.viewId) {
            const viewResResult = element;
            this.viewsLists = viewResResult;
            this.viewName = this.viewsLists.displayViewHeading;
            this.viewType = this.viewsLists.viewType;
            this.lastUpdatedDate = this.viewsLists.lastUpdateDate;
            this.loadPreviewResults();
            this.spinner.hide();
          }
        }
      });
    }   
    this.utilService.goToTop();
  }

  ngOnInit(): void {
    this.spinner.show();
    if (this.viewId) {
      this.loadFields();
      this.loadOperator();
    } else {
      this.detailsService.viewId.subscribe(res => {
        this.viewId = res.viewId;
        this.loadFields();
        this.loadOperator();
      })
    }
    // this.loadOperator();
    this.initForm();
    this.onAddNew();
    this.trackFormArrayChanges();
    // this.addTags();
    // this.removeTags();
    this.listenToCustomQueryChangesAndValidate()
  }
  listenToCustomQueryChangesAndValidate() {
    const allFields = this.requestForm.get('allFields') as FormArray;
  
    allFields.controls.forEach((control, index) => {
      let query = control.get('customQuery')?.value;
       
        if (query) {
            this.validateCustomQuery(control, index); 
          }
        
    });
}
validateCustomQueryOnTabChange(){
   let  parsedInputArray:any = []
  const allFields = this.requestForm.get('allFields') as FormArray;

  allFields.controls.forEach((field, index) => {
    let parts = this.parseQuery(field.value.customQuery)
    parsedInputArray.push(parts)

  });
  console.log(parsedInputArray);
  parsedInputArray.forEach((row:any,index:any) => {
      this.checkIsValidColumnAndOperator(row,index)
  });
}
  ngAfterViewInit() {
    this.detailsService.viewId.subscribe(res => {
      this.viewId = res.viewId;
      // this.requestDesc = JSON.parse(res.result.requestDesc)
      this.data = res.userInput.filters;
      this.data.forEach((x: any, index: any) => {
        const flag = (x.type === "sql" || x.activetab === "MySQL");
        this.onClickSetValue(flag ? 'MySQL' : 'Filters', index, flag ? 1 : 0);
        if (index > 0) {
          this.allFields.push(
            new FormGroup({
              fieldName: new FormControl(null, [Validators.required]),
              operator: new FormControl(null, Validators.required),
              fieldValue: new FormControl(null, [Validators.required]),
              customQuery: new FormControl(null, [Validators.required]),
              andOrValue: new FormControl(),
              activetab: new FormControl(flag ? 'MySQL' : 'Filters'),
            })
          )

        }
      })

      this.data.forEach((x: any, index: any) => {
        const flag = (x.type === "sql" || x.activetab === "MySQL");
        if(flag){
           return (<FormArray>this.requestForm.get('allFields')).at(index).patchValue({
          customQuery: flag ? x['value']  ?? x['customQuery']: '',
          andOrValue: x['logicalOperator'] == "AND" ? false : true
        })
        }else{
           return (<FormArray>this.requestForm.get('allFields')).at(index).patchValue({
          fieldName: x['fieldName'],
          operator: x['operator'],
          fieldValue: !flag ? x['value'] ?? x['fieldValue']: '',
          andOrValue: x['logicalOperator'] == "AND" ? false : true
        })
        }
      })


    })
    // this.getAllTags();
    this.getTagsByView();
  }
  trackFormArrayChanges() {
    this.allFields.valueChanges.subscribe((changes) => {
      this.isSubmitButtonDisabled = false;
      this.isApplied = false; 
    });
  }

  isSubmitDisabledYes(): boolean {
    const firstField = this.allFields.at(0);
    return firstField.invalid || firstField.value.fieldName.trim() === '';
  }


  getControls() {
    return (this.requestForm.get('allFields') as FormArray).controls;
  }

  onErrorClose(): void {
    this.errorMessage = null;
    this.warningMessage = null;
  }

  loadPreviewResults(isApplied:boolean=false) {
    this.spinner.show();
    this.isPreviewLoading = true;
    this.detailsService
      .getPreviewResults(
        this.userId,
        this.viewType,
        this.viewName,
        this.condition,
        this.limit,
        this.page,
        this.customLabel,
        this.viewId,
        this.authId,
        this.requestId,
        this.requestForm.get('allFields').value
      )
      .subscribe({
        next: (res: any) => {
          this.isPreviewLoading = false;
          if (res.code === 400) {
            this.initializeSaveDraftRequest();
            this.warningMessage = null;
            this.errorMessage = res.message;
            this.isSubmitButtonDisabled = false;
            this.submitDisabledFlag = false;
            this.spinner.hide();

          } else if (res.code === 204) {
            this.initializeSaveDraftRequest();
            this.errorMessage = null;
            this.warningMessage = res.message;
            this.isSubmitButtonDisabled = false;
            this.submitDisabledFlag = false;
            this.spinner.hide();

          } else {
            const previewRes = res;
            this.totalPreviewCount = previewRes.totalCount;
            this.filteredCount = previewRes?.filteredCount;
            this.previewResults = previewRes.result;
            this.previewSchemas = previewRes.schema;
            this.errorMessage = null;
            this.warningMessage = null;
            this.spinner.hide();
            if (this.submitDisabledFlag) {
              this.isSubmitButtonDisabled = true;
            }
            if(isApplied){
              this.isApplied = true;
            }
          }
          if (this.scrollTop) {
            this.utilService.autoScrollUp();
          }
        },
        error: (err) => {
          this.spinner.hide();
          this.isSubmitButtonDisabled = true;
          this.isApplied = false;
          this.isPreviewLoading = false;
        },
      });
  }



  getPreviewKeys() {
    return this.previewResults && this.previewResults.length > 0
      ? Object.keys(this.previewResults[0])
      : [];
  }
  getFilteredCol() {
    return this.fields && this.fields.length > 0
      ? this.fields.map((item:any) => item.displayName)
      : [];
  }

  loadFields() {
    this.spinner.show();
    this.detailsService
      .getField(this.viewId, this.userId)
      .subscribe((res: any) => {
        const fieldRes = res;
        this.fields = fieldRes.result;
        this.filteredCol = this.getFilteredCol()
        this.spinner.hide();
      });
  }

  loadOperator() {
    this.spinner.show();
    this.detailsService.getOperators().subscribe((res: any) => {
      const operatorRes = res;
      this.operators = operatorRes.result;
      this.operatorsList = this.getLogicalOperatorsKeys()
      this.spinner.hide();
    });
  }

  onAddNew() {
    (<FormArray>this.requestForm.get('allFields')).push(
      new FormGroup({
        fieldName: new FormControl(null, [Validators.required]),
        operator: new FormControl(null, Validators.required),
        fieldValue: new FormControl(null, [Validators.required]),
        customQuery: new FormControl('', [Validators.required]),
        andOrValue: new FormControl(),
        activetab:new FormControl('Filters')
      })
    );
    if (this.formlist.length != this.allFields.length) {
      for (
        let i = 0;
        i < this.allFields.length - this.formlist.length + 1;
        i++
      ) {
        this.formlist.push(0);
      }
    }
    this.listenToCustomQueryChangesAndValidate()
  }

  onDeleteRow(index: number) {
    if (this.allFields.length > 1) {
      (<FormArray>this.requestForm.get('allFields')).removeAt(index);
      this.formlist.splice(index, 1);
    }
  }

  toggleClick(index: any) {
    this.isChecked = !this.isChecked;
    this.result = '';
  }

  private initForm() {
    this.requestForm = new FormGroup({
      allFields: new FormArray([]),
      customQuery: new FormControl(''),
      andOrValue: new FormControl(),
    });
    this.formlist = new Array(this.allFields.length).fill(0);
  }

  get allFields() {
    return this.requestForm.get('allFields') as FormArray;
  }

  onApply() {
    this.scrollTop = false;
    this.loadCondition();
    this.loadPreviewResults(true);
  }

  loadCondition() {
    if (this.result) {
      this.result = '';
    }
    this.savedraftrequest.userInput.filters.length = 0;
    var seq = 1;
    const size = this.allFields.controls.length;
    const allFields = this.allFields.controls.map((allField:any, index) => {
      let myFilter: Filter = {
        seqId: 0, // Initialize with default or real values
        type: '', // Will be set based on conditions
        value: '' // Will be set based on conditions
      };

      let fieldName = allField.get('fieldName').value;
      let operator = allField.get('operator').value;
      let fieldValue = allField.get('fieldValue').value;
      let customQuery = allField.get('customQuery').value;
      if (allField.value.activetab == "MySQL") {
        fieldName = "";
        operator = "";
        fieldValue = "";
        customQuery = allField.get('customQuery').value;
     } else if (allField.value.activetab == "Filters") {
        fieldName = allField.get('fieldName').value;
        operator = allField.get('operator').value;
        fieldValue = allField.get('fieldValue').value;
        customQuery = "";
     }
      this.andOrValue =
        allField.get('andOrValue').value === true ? 'OR' : 'AND';

      if (seq !== 1)
        myFilter.logicalOperator = this.andOrValue;

      myFilter.seqId = seq;

      if ((fieldName == ""|| fieldName == undefined) && (operator == ""||operator==undefined) && (fieldValue == "" || fieldValue==undefined )) {
        myFilter.value = customQuery;
        myFilter.type = 'sql';
        this.returnValue += `${this.andOrValue} ${customQuery} `;
      } else if (operator.includes('LIKE')) {
        
        myFilter.type = 'filter';
        myFilter.fieldName = fieldName;
        myFilter.value = fieldValue;
        myFilter.operator = operator;

        this.returnValue += `${this.andOrValue} ${fieldName} ${operator} ('%${fieldValue}%') ${customQuery} `;
      } else if (operator.includes('IN')) {

        myFilter.type = 'filter';
        myFilter.fieldName = fieldName;
        myFilter.value = fieldValue;
        myFilter.operator = operator;
        let str = fieldValue;
        const splittedArray = str.split(',');

        let finalString = '(';
        splittedArray.forEach((str1: any) => {
          finalString = finalString + "'" + str1 + "',";
        });
        finalString = finalString.slice(0, -1);
        finalString = finalString + ')';
        this.returnValue += `${this.andOrValue} ${fieldName} ${operator} ${finalString} ${customQuery} `;
      } else {
        myFilter.type = 'filter';
        myFilter.fieldName = fieldName;
        myFilter.value = fieldValue;
        myFilter.operator = operator;

        this.returnValue += `${this.andOrValue} ${fieldName} ${operator}` +(fieldValue!=""?` '${fieldValue}'`:'')+` ${customQuery} `;


      }
      this.savedraftrequest.userInput.filters.push(myFilter);

      seq = seq + 1;

    });
    //this.savedraftrequest.userInput = this.userInput;
    let splitStr = this.returnValue.slice(0, this.returnValue.indexOf(' '));

    this.result = this.returnValue.substring(
      splitStr.length + 1,
      this.returnValue.length
    );
    this.condition = this.result.trim();
    if (this.condition === '') {
      this.condition = null;
    }
    this.returnValue = '';
    this.scrollTop = true;
    this.submitDisabledFlag = true;
  }
  openConfirmationPopup(){
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          title: 'Confirmation',
          message: 'The request you are trying to Submit has more than 1047552 records and due to performance limit, Output File will be limited to have 1047552 records only.',
          subMessage: 'Do you want to proceed?'
          
        },
         disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result){        
          this.onSubmit();  
        }                        
      });
    }
  onSubmitButton() {
  const UPPER_LIMIT = 1047552;
  let countToCheck = this.filteredCount == 0 ? this.totalPreviewCount : this.filteredCount;
  if (countToCheck <= UPPER_LIMIT) {
      this.onSubmit();
    } else {
      this.openConfirmationPopup()
    }
  }

  onSubmit() {
    this.spinner.show();
    this.initializeSaveDraftRequest();
    this.loadCondition();
    this.savedraftrequest.userId = this.userId;
    this.savedraftrequest.viewId = this.viewId;
    this.savedraftrequest.authId = this.authId;
    this.savedraftrequest.userInput.customLabel = this.customLabel;
    this.savedraftrequest.userInput.condition = this.condition;
    this.savedraftrequest.limit = 100;
    this.savedraftrequest.page = 1;

    ///
    // if(this.router.url.split("/")?.[1] === "copyrequest"){
    //   this.requestId=null
    // }
    if ((this.requestId !== '' && this.requestId !== null && this.requestId !== undefined)
      &&this.router.url.split("/")?.[1] !== "copyrequest")
      this.savedraftrequest.requestId = "DataQuest-" + this.requestId;
    else 
      this.savedraftrequest.requestId = null;

    this.detailsService
      .getSubmitRequest(
          this.savedraftrequest
      )
      .subscribe({
        next: (res: any) => {
          if (res.code === 400) {
            this.errorMessageSubmit = res.message;
            this.utilService.goToTop();
            this.spinner.hide();
            setTimeout(() => {
              this.errorMessageSubmit = null;
            }, 5000);
          } else {
            this.requestId = null;
            const submitRes = res;
            const submitResult = submitRes.result;
            this.submitReqId = submitResult.requestId;
            this.errorMessageSubmit = null;
          //  this.successMessage = `Request ID ${this.submitReqId} generated successfully for the submitted query.`;
            this.successMessage = res.message;
            this.spinner.hide();
            this.utilService.goToTop();
            setTimeout(() => {
              this.successMessage = null;
              this.router.navigate(['/home']);
            }, 5000);
          }
        },
        error: (err) => {
          this.spinner.hide();
          this.errorMessageSubmit = err.result.error;
          setTimeout(() => {
            this.successMessage = null;
          }, 5000);
        },
      });
  }

  onClickSetValue(tabValue: any, rowindex: any, columnindex: any,onClick=false,item:any=null) {
    this.isApplied = false;
    this.activeTabIndex = columnindex;
    this.rowIndex = rowindex;
    this.formlist[rowindex] = columnindex;
    this.allFields?.at(rowindex)?.patchValue({
      activetab:tabValue
    })
    if (this.allFields.length > 0 && !onClick) {
      return
    } else {
      // used to reset the fields at index position
       if (tabValue === 'MySQL') {
      //   (<FormArray>this.requestForm.get('allFields')).at(rowindex).patchValue({
      //     fieldName: null,
      //     operator: null,
      //     fieldValue: null,
      //   });
        this.listenToCustomQueryChangesAndValidate();
       } else if (tabValue === 'Filters') {
      //   (<FormArray>this.requestForm.get('allFields'))
      //     .at(rowindex)
      //     .get('customQuery')
      //     .patchValue('');
       }
    }

  }

  goBack() {
    this.router.navigate(['/home']);
  }

  isPreviewEnabled(): boolean {
    return this.allFields.controls.every((group: any) => {
      return (
        (group.get('activetab').value == 'Filters' && group.get('fieldName').valid &&
          group.get('operator').valid &&
          group.get('fieldValue').valid) ||(
          group.get('activetab').value !== 'Filters'&&group.get('customQuery').valid)
      );
    });
  }

  isSaveDisabled(): boolean {
    // return this.allFields.controls.every((group: any) => {
    //   if (this.isPreviewEnabled() && !(!this.isSubmitButtonDisabled &&
    //     this.isSubmitEnabled() &&
    //     this.isSubmitDisabledYes())) {
    //     return false;
    //   }
    //   else
    //     return true;
    // });
    
    if(this.isSubmitEnabled()){
      return this.allFields.controls.every((group: any) => {
        if (this.isPreviewEnabled() && this.isApplied) {
          return false;
        }
        else
          return true;
      });
    }else{
        return false;
    }
  }

  isSubmitEnabled(): boolean {
    return this.allFields.controls.some((group: any) => {
      const isFiltersTab = group.get('activetab').value === 'Filters';
      if (isFiltersTab) {
        return (
          (group.get('fieldName')?.value !== null && group.get('fieldName')?.value !== '') &&group.get('fieldName')?.value !== undefined||
          (group.get('operator')?.value !== null && group.get('operator')?.value !== '') && group.get('operator')?.value !== undefined ||
          (group.get('fieldValue')?.value !== null && group.get('fieldValue')?.value !== ''&& group.get('fieldValue')?.value !== undefined)
        );
      } else {
        return group.get('customQuery')?.value !== null && group.get('customQuery')?.value !== ''&& group.get('customQuery')?.value !== undefined;
      }
    });
  }
  
  onSaveDraft() {
    this.initializeSaveDraftRequest();
    this.loadCondition();
    this.spinner.show();
    this.savedraftrequest.userId = this.userId;
    this.savedraftrequest.viewId = this.viewId;
    this.savedraftrequest.authId = this.authId;
    this.savedraftrequest.userInput.customLabel = this.customLabel;
    this.savedraftrequest.userInput.condition = this.condition;
    if ((this.requestId !== '' && this.requestId !== null && this.requestId !== undefined)
      &&this.router.url.split("/")?.[1] !== "copyrequest")
      this.savedraftrequest.requestId = "DataQuest-" + this.requestId;
    this.detailsService
      .getSaveDraft(
        this.savedraftrequest
      )
      .subscribe({
        next: (res: any) => {
          if (res.code === 400) {
            this.errorMessageSubmit = res.message;
            this.utilService.goToTop();
            this.spinner.hide();
            setTimeout(() => {
              this.errorMessageSubmit = null;
            }, 5000);
          } else {
            const savedraftres = res;
            this.requestId = savedraftres.result.requestId;
            this.requestUpdatedDate = savedraftres.result.requestUpdatedDate;
            this.getTimeInterval();
            this.errorMessageSubmit = null;
            this.successMessage = `${savedraftres.message}`;
            this.spinner.hide();
            this.utilService.goToTop();
            setTimeout(() => {
              this.successMessage = null;

            }, 5000);
          }
        },
        error: (err) => {
          this.spinner.hide();
          this.errorMessageSubmit = err.result.error;
          setTimeout(() => {
            this.successMessage = null;
          }, 5000);
        },
      });
  }

  initializeSaveDraftRequest() {
    this.savedraftrequest = {
      userId: 0,
      viewId: 0,
      authId: 'default',
      userInput: {
        condition: '',
        filters: []
      }
    };
  }

  getTimeInterval() {
    let that = this;

    if (this.requestId != undefined && this.requestUpdatedDate != undefined) {
      this.updatedDate = this.requestUpdatedDate;
    }
    let id = setInterval(function () {
      if (that.userId) {
        let date = new Date(that.requestUpdatedDate);
        let current = new Date();

        // Create a UTC version of the current date
        let currentUtc = new Date(
          Date.UTC(
          current.getUTCFullYear(),
          current.getUTCMonth(),
          current.getUTCDate(),
          current.getUTCHours(),
          current.getUTCMinutes(),
          current.getUTCSeconds()
          )
        );

        let diffInMs = Math.abs(currentUtc.getTime() - date.getTime());
        let diffInSeconds = Math.floor(diffInMs / 1000);
        let diffInMinutes = Math.floor(diffInSeconds / 60);
        let diffInHours = Math.floor(diffInMinutes / 60);
        let diffInDays = Math.floor(diffInHours / 24);

        if (diffInDays > 0) {
          that.timeInterval = `${diffInDays} days`;
        } else if (diffInHours > 0) {
          that.timeInterval = `${diffInHours} hours`;
        } else if (diffInMinutes > 0) {
          that.timeInterval = `${diffInMinutes} minutes`;
        } else {
          that.timeInterval = `${diffInSeconds} seconds`;
        }
      } else {
        clearInterval(id);
      }
    }, 5000);
  }

  cleanURL(routeUrl: any, id: any) {
    this.location.replaceState(`${routeUrl}/${id}`);
  }


  selectEvent(item: any) {
    if(!item.id){
      this.addNewTag(item.name,true)
     }else{
       this.addTags(item);
     }
  }
  
  onChangeSearch(search: any) {
  }

  onFocused(e: any) {
  }

  getAllTags(){
    this.detailsService.getAllTags().subscribe(res=>{
      if(res){
        this.tagList=res.result.map((x:any)=>({id:x.id,name:x.tagName})).filter((md:any) => 
          this.tagsByViewId.every((fd:any) => fd.id !== md.id))
        if(this.autocompleteText&&this.autocompleteText!=='') this.allTags = [...this.tagList,{name: this.autocompleteText}]
        else this.allTags = [this.tagList];
      }
    })
  }
  getTagsByView() {
    this.addtagFlag = false;
    if (!this.viewId) {
      this.detailsService.viewId.subscribe(res => {
        this.viewId = res.viewId;
        this.detailsService.getTagsByView(this.viewId).subscribe(res => {
          if (res) {
            this.tagsByViewId = res.result
            this.autocompleteText="";
          }
          this.getAllTags()
        })
      })
    } else {
      this.detailsService.getTagsByView(this.viewId).subscribe(res => {
        if (res) {
          this.tagsByViewId = res.result
          this.autocompleteText="";
        }
        this.getAllTags()
      })
    }
  }
  addTags(item:any,addNew=false){
    if(addNew){
      this.detailsService.addTags(this.viewId,[],[item]).subscribe(res=>{
        if(res){
          this.auto.clear()
          this.getTagsByView();
        } 
      })
    }else{
      this.detailsService.addTags(this.viewId,[item.id],[]).subscribe(res=>{
        if(res){
          this.auto.clear()
          this.getTagsByView();
        }
      })
    }
  }

  
  removeTags(id:any){
    this.detailsService.removeTags(this.viewId,id).subscribe(res=>{
      if(res){
        // this.auto.clear()
        this.getTagsByView(); 
      }
    })
  }
  showAddInput(){
    this.addtagFlag=true;
  }
  addNewTag(e:any,flag=false){
    if(flag==true){
      this.addTags(e,true)
    }else{
      this.addTags(e.target.value,true)
    }
  } 
  setCustomLabel(e:any){
    this.customLabel=e.target.value;
  }
  setText(e:any){
    this.autocompleteText=e.target.value;
    if(this.autocompleteText&&this.autocompleteText!=='') this.allTags = [...this.tagList,{name:  this.autocompleteText}];
    else this.allTags = [this.tagList];
  }

  editDataView(){
    this.spinner.show();
    this.router.navigate(['/edit-dataview', this.viewId],{ state: { reqFrom:'detailView'}  });
    this.spinner.hide();
  }


  ////poc started ////

  getLogicalOperatorsKeys() {
    let operatorNames = this.operators.map((item:any) => item.operator_name);
    return operatorNames && operatorNames.length > 0
    ? operatorNames
    : [];
  }

  getSuggestions(value: string): string[] {
    this.filteredCol = this.getFilteredCol()
    this.operatorsList  = this.getLogicalOperatorsKeys()
    const parts = this.parseQuery(value); 
    const lastPart = parts[parts.length - 1]; 
 
    if (!lastPart) {
      return []; 
    }

    const suggestionLists: { [key in 'column' | 'operator' |  'logicalOperator']: string[] | any } = {
      column: this.filteredCol,
      operator: this.operatorsList,
      logicalOperator: this.logicalOperators
    };
    
    const suggestions = suggestionLists[this.currentStage as 'column' | 'operator' |  'logicalOperator'].filter((item:any) =>
      item.toLowerCase().includes(lastPart.toLowerCase()) 
  ) || []; 
    
   return suggestions;
  }


  onSelectionChange(option: string, rowIndex: any, input: HTMLInputElement): void {
    const row = (this.requestForm.get('allFields') as FormArray).at(rowIndex) as FormGroup;
    let customQuery = row.get('customQuery')?.value;
    const parts = this.parseQuery(customQuery);
    if (parts.length > 0) {
      parts[parts.length - 1] = option;
    } else {
      parts.push(option);
    }

    this.currentStage = this.getCurrentStage(parts);
    // Add a space at the end of the value
    row.get('customQuery').setValue(parts.join(' ') + ' ');


    //  keep cursor at the end
    const newValue = parts.join(' ') + ' ';
    row.get('customQuery')?.setValue(newValue, { emitEvent: false });
    setTimeout(() => {
      const pos = newValue.length;
      input.focus();
      input.setSelectionRange(pos, pos);
      input.scrollLeft = input.scrollWidth; // 🔥 THIS fixes "cursor not visible"
    }, 0);
  }

  
  parseQuery(query: string): any[] {
      if ((!this.operatorsList || !Array.isArray(this.operatorsList) || this.operatorsList.length === 0)||
          (!this.filteredCol || !Array.isArray(this.filteredCol) || this.filteredCol.length === 0)) {
        return [];
      }
      const operators = [...this.operatorsList, ...this.logicalOperators];
      const sortedOps = operators.sort((a, b) => b.length - a.length);
      const operatorPattern = sortedOps
        .map(op => `\\b${op.replace(/ /g, '\\s+')}\\b`)
        .join('|');

      const regex = new RegExp(
        `(${operatorPattern})` +
        `|(\\([^()]*\\))` +            // Round brackets
        `|(\\[[^\\[\\]]*\\])` +        // Square brackets
        `|('[^']*'|"[^"]*")` +
        `|([^\\s()\\[\\]'"]+)`,
        'gi'
      );

      const rawTokens: string[] = [];
      let match: RegExpExecArray | null;

      while ((match = regex.exec(query)) !== null) {
        const token = match[0].trim();
        if (token) rawTokens.push(token);
      }

      const operatorSet = new Set(sortedOps.map(op => op.toUpperCase()));
      const finalTokens: string[] = [];
      let buffer: string[] = [];

      for (const token of rawTokens) {
        const upper = token.toUpperCase();
        const isOperator =
          operatorSet.has(upper) ||
          [...operatorSet].some(op => op.startsWith(upper));

        if (
          isOperator || token.startsWith('(') || token.endsWith(')') ||
         token.startsWith('[') || token.endsWith(']') || /^['"]/.test(token)) {
          if (buffer.length) {
            finalTokens.push(buffer.join(' '));
            buffer = [];
          }
          finalTokens.push(token);
        } else {
          buffer.push(token);
        }
      }

      if (buffer.length) {
        finalTokens.push(buffer.join(' '));
      }
      return finalTokens;
 }
 onInputKeyPress(event:any){
  console.log(event);
 }

  onInputChange(rowIndex: any, event: any,input: HTMLInputElement) {
    const cursorPos = input.selectionStart ?? 0;
    const row = (this.requestForm.get('allFields') as FormArray).at(rowIndex) as FormGroup;
    let customQuery = row.get('customQuery')?.value;
    if (!customQuery || customQuery.trim() === '') {
      this.currentStage = 'column';
      this.filteredOptions = undefined;
      return;
    } else {
      this.filteredOptions = row.get('customQuery').valueChanges.pipe(
        startWith(customQuery),
        debounceTime(300),
        distinctUntilChanged(),
        map((value: any) => {
             if (event.data) {
            this.listenToCustomQueryChangesAndValidate();
            return this.getSuggestions(value);
          } else {
            return null;
          }
        })
      );
    }

     // Restore cursor AFTER Angular updates the DOM
    setTimeout(() => {
      input.focus();
      input.setSelectionRange(cursorPos, cursorPos);
      input.scrollLeft = input.scrollWidth;
    }, 0);
  }
       

  getCurrentStage(parts: string[]): string {
    const stageOrder = ['column', 'operator','logicalOperator'];
    const lastPart = parts[parts.length - 1];
   if (lastPart && ['AND', 'OR'].includes(lastPart.toUpperCase())) {
      return 'column';
    }
     if (lastPart && !this.operatorsList.includes(lastPart) && !this.filteredCol.includes(lastPart)) {
      return 'logicalOperator';  
    }
    const lengthMod = parts.length % 4;
    const expectedStage = stageOrder[lengthMod];
  
    return expectedStage;
  }



  

  displayFn(option: string): string {
    return option ? option : '';
  }

extractValueList(row:any,index:any){
    let valuesList: any[] = [];
    let invalidvaluesList: any[] = []; 
    row.forEach((col: any, i:any) => {
      if (this.operatorsList.includes(col)) {
        const value = row[i + 1];
        if (value) {
          valuesList.push(value);
    
        //   // Case A: For =, <> operators
            if (col === '=' || col === '<>' || col === '!=') {
              const startsCorrectly = /^[0-9]|^'/.test(value);
              const containsBrackets = /[\[\]\(\)\{\}]/.test(value);
              const endsWithOperatorOrSpecial = /[=<>!^|&+\-*/%]$/.test(value.trim());
              if (!startsCorrectly || containsBrackets || endsWithOperatorOrSpecial) {
              invalidvaluesList.push(value);
              let errMsg = '';
              if (!startsCorrectly) {
                errMsg = 'Invalid value for Equality operator. Value should start either with a number or enclosed in single quotes. ';
              }
              if (containsBrackets) {
                errMsg = 'Invalid value for Equality operator. Value should not contain brackets. ';
              }
              if (endsWithOperatorOrSpecial) {
                errMsg = 'Invalid value for Equality operator. Value should not end with an operator or special character.';
              }
              this.errorsList.push({ 'index': index, 'err': [...invalidvaluesList] + ' ' + errMsg.trim() });
              this.allFields.controls[index].get('customQuery')?.setErrors({ 'index': index, 'err': [...invalidvaluesList] + ' ' + errMsg.trim() });
              }
            }
            //  // Case B: For Comparison(>, >=, <, <=):  operators
            if (['>', '>=', '<', '<='].includes(col)) {
              // Allow values that start with a letter, number, or single quote, and include hyphens, underscores, spaces, etc.
              const isValidAlphaNum = /^['"]?[\w\- ]+['"]?$/.test(value); // letters, numbers, _, -, space, optional quotes
              const containsBrackets = /[\[\]\(\)\{\}]/.test(value);

              if (!isValidAlphaNum || containsBrackets) {
                invalidvaluesList.push(value);
                this.errorsList.push({'index':index,'err':[...invalidvaluesList]+' invalid value for Comparison operator'});
                this.allFields.controls[index].get('customQuery')?.setErrors({'index':index,'err':[...invalidvaluesList]+' invalid value for Comparison operator'});
              }
            }
        //     // Case C: Inline Search (LIKE, NOT LIKE): 
            if (col === 'LIKE' || col === 'NOT LIKE') {
              const isWrappedInParentheses = /^\(.*\)$/.test(value);
              const innerValue = isWrappedInParentheses ? value.slice(1, -1) : value;
              const isQuoted = /^'.*'$/.test(innerValue);
              const hasPercent = /%/.test(innerValue);
            
              if (!isWrappedInParentheses) {
                invalidvaluesList.push(value);
                this.errorsList.push({'index':index,'err':[...invalidvaluesList]+' LIKE or NOT LIKE value must be wrapped in parentheses'})
                this.allFields.controls[index].get('customQuery')?.setErrors({'index':index,'err':[...invalidvaluesList]+' LIKE or NOT LIKE value must be wrapped in parentheses'});

              } else if (!isQuoted) {
                invalidvaluesList.push(value);
                this.errorsList.push({'index':index,'err':[...invalidvaluesList]+' Value inside parentheses must be enclosed in single quotes.'})
                this.allFields.controls[index].get('customQuery')?.setErrors({'index':index,'err':[...invalidvaluesList]+' Value inside parentheses must be enclosed in single quotes.'});

              } else if (!hasPercent) {
                invalidvaluesList.push(value);
                this.errorsList.push({'index':index,'err':[...invalidvaluesList]+" LIKE or NOT LIKE pattern must contain at least one '%' wildcard."})
                this.allFields.controls[index].get('customQuery')?.setErrors({'index':index,'err':[...invalidvaluesList]+" LIKE or NOT LIKE pattern must contain at least one '%' wildcard."});

              } 
            }
            // Case D: Multiple Equality (IN, NOT IN):
            if (col === 'IN' || col === 'NOT IN') {
              
              const isEnclosed = /^\(.*\)$/.test(value); 
      
              if (!isEnclosed) {
                invalidvaluesList.push(value);
                this.errorsList.push({'index':index,'err':[...invalidvaluesList]+" value Must be enclosed in parentheses"})
                this.allFields.controls[index].get('customQuery')?.setErrors({'index':index,'err':[...invalidvaluesList]+" value Must be enclosed in parentheses"});

              } 
            }
        }
      }
    });
     
      return valuesList;
}

validateCustomQuery(control:any,index:any){
  const customQuery = control.get('customQuery')?.value;  // Get the customQuery value for this control
  
  if (customQuery) {
    const parsedRow = this.parseQuery(customQuery);  // Parse the query for this control's value
    this.checkIsValidColumnAndOperator(parsedRow,index);  // Validate this row's query
  }
}

checkIsValidColumnAndOperator(row:any,index?:any){
    let ColumnAndOperatorList:any = [];
    let invalidColumnAndOperatorAndValuesList:any = [];
    let actualColumnAndOperatorList = [];
    actualColumnAndOperatorList = [...this.filteredCol , ...this.operatorsList, ...this.logicalOperators];
    row.forEach((col:any,index:any)=>{
      if (actualColumnAndOperatorList.includes(col)) {
        ColumnAndOperatorList.push(col)  
      }
      else{
        invalidColumnAndOperatorAndValuesList.push(col)  
      }
    })
    let extractValueList = this.extractValueList(row,index);
    
    extractValueList.forEach((col:any)=>{
    if (invalidColumnAndOperatorAndValuesList.includes(col)) {
      invalidColumnAndOperatorAndValuesList.splice(invalidColumnAndOperatorAndValuesList.indexOf(col),1);
    }
    })
    if(invalidColumnAndOperatorAndValuesList.length>0){
      this.errorsList.push({'index':index,'err':[...invalidColumnAndOperatorAndValuesList]+' invalid Column or operator'})
      this.allFields.controls[index].get('customQuery')?.setErrors({'index':index,'err':[...invalidColumnAndOperatorAndValuesList]+' invalid Column or operator'});
    }
  }
}


